<template>
    <div class="modal-headers tw-flex tw-bg-blue-400 tw-px-4">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'ModalHeaders',
    };
</script>
